import { TextField } from "@material-ui/core";
import useValidations from "hooks/useValidations";
import { lang } from "i18nLang";
import { useState } from "react";
import { ContractRowMovementStore } from "store";

interface IProps {
  classes: any;
  onChangeData: (data: any) => void;
  onBlurInput: (field: string, value: any, isValid: boolean) => void;
}

const CancellationMassForm = ({
  classes,
  onChangeData,
  onBlurInput,
}: IProps) => {
  const [data, setData] = useState({
    codes: "",
  });

  const { validated, validateFields } = useValidations({
    codes: {
      required: true,
      custom: function (value: string) {
        const codes = value.split(";");
        for (const code of codes) {
          const result = ContractRowMovementStore.verifyExistedCode(code, true);
          if (result) return result;
        }
        return;
      },
    },
  });

  const handleChangeInput = (ev) => {
    const exp = /[^0-9\;\.]/g;
    const { name, value } = ev.target;
    const newData = { ...data };
    newData[name] = value.replace(exp, "");
    setData(newData);
    onChangeData(newData);
  };

  const handleBlurInput = (ev) => {
    const { name, value } = ev.target;
    const valid = validateFields({ [name]: value });
    onBlurInput(name, value, valid);
  };

  return (
    <form style={{ width: "100%" }} onSubmit={(ev) => ev.preventDefault()}>
      <TextField
        name="codes"
        label={lang("addsAndCancels.codes")}
        className={classes.input}
        color="secondary"
        value={data.codes}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        error={!validated.codes.valid}
        helperText={
          validated.codes.text || lang("addsAndCancels.codesHelperText")
        }
        fullWidth
      />
    </form>
  );
};

export default CancellationMassForm;
